/**
 * Reads a File as a raw base64 string (no `data:...;base64,` prefix) —
 * m46-parking's evidence upload (POST /contraventions/:id/evidence) takes
 * `dataBase64` as a plain base64 payload via Zod's `z.string().min(1)`, not a
 * data URL.
 */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result ?? '');
      const commaIndex = result.indexOf(',');
      resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : result);
    };
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}
